import React, { useEffect, useState } from "react";
import { BottomBar, Button, ButtonGroup, CardsRenderer, Checkbox, DateRange, Pagination, Receipt, Searchbox, Table, TableCardRender, TableSwitch, Toast } from "../../../../../Components";
import { FiEye } from "react-icons/fi";
import moment from "moment";
import apis from "../../../../../Utils/apis";
import { get } from "../../../../../Utils/axios";
import ViewReceipt from "../../../../../Components/Receipt/ViewReceipt";
import { StampToDate } from "../../../../../Utils/utils";
import StatusIndicator from "../../../../../Components/Receipt/Components/status";
import SubmitReceipt from "./SubmitReceipt";
import AddReceipt from "./AddReceipt";
import { useClientSettings } from "../../../../../Hooks/useClientSettings";

function WithMe() {
	const { isEnabled } = useClientSettings();
	const expenseEnabled = isEnabled("ORGANIZATION") && isEnabled("EXPENSE");

	const [ViewMode, setViewMode] = useState();
	const [OpenId, setOpenId] = useState();
	const [Dragging, setDragging] = useState();

	const [ReceiptStatus, setReceiptStatus] = useState({ label: "Drafts", value: "drafts" });
	const initial = {
		receipts: [],
		count: 0,
		pages: 0,
	};
	const [Query, setQuery] = useState({
		search: "",
		page: 1,
		dates: {
			startDate: moment().subtract(30, "days").valueOf(),
			endDate: moment().valueOf(),
		},
	});

	const [SelectedReceipts, setSelectedReceipts] = useState([]);
	const [Receipts, setReceipts] = useState(initial);
	const [Loading, setLoading] = useState(true);
	const PendingReceipts = Receipts.receipts.filter((receipt) => receipt.status !== "draft" && receipt.status !== "outOfPolicy");
	const [ShowSelectExpenses, setShowSelectExpenses] = useState(false);

	useEffect(() => {
		fetchReceipts(ReceiptStatus.value, Query);
	}, [ReceiptStatus, Query]);

	const fetchReceipts = (type, query) => {
		setLoading(true);
		let url;
		if (type === "drafts") {
			url = apis.getWithMeReceipts;
		} else if (type === "submitted") {
			url = apis.getPendingReceipts;
		} else if (type === "completed") {
			url = apis.getCompletedReceipts;
		}

		get(
			url,
			{
				...query,
				dates: {
					startDate: moment(query.dates.startDate).toDate(),
					endDate: moment(query.dates.endDate).toDate(),
				},
			},
			(r, e) => {
				if (r) {
					setReceipts(r);
					setLoading(false);
				} else if (e) {
					Toast.handleError(e);
					setLoading(false);
				}
			}
		);
	};

	const handleSelect = (receipt) => {
		if (receipt.status === "draft") {
			Toast.error("Drafts cannot be selected");
			return;
		}
		//Check if the receipt is already selected
		if (SelectedReceipts.some((r) => r.id === receipt.id)) {
			setSelectedReceipts(SelectedReceipts.filter((r) => r.id !== receipt.id));
		} else {
			setSelectedReceipts([...SelectedReceipts, receipt]);
		}
	};

	return (
		<>
			{ReceiptStatus.value === "drafts" && <SubmitReceipt loading={Loading} dragging={Dragging} onReload={() => fetchReceipts(ReceiptStatus.value, Query)} selectedReceipts={SelectedReceipts} setSelectedReceipts={setSelectedReceipts} />}
			<div className="p-4 pb-24">
				<div className="gap-4 flex-center-between">
					{expenseEnabled && (
						<ButtonGroup
							onClick={setReceiptStatus}
							size="xs !p-1.5"
							selected={ReceiptStatus}
							className="text-sm"
							options={[
								{ label: "Drafts", value: "drafts" },
								{ label: "Submitted", value: "submitted" },
								{ label: "Completed", value: "completed" },
							]}
						/>
					)}
					<div className="gap-2 align-center">
						<Searchbox placeholder="Search receipts" cmd="s" onChange={(search) => setQuery({ ...Query, search })} />
						{ReceiptStatus.value === "completed" && <DateRange maxDate={moment().startOf("date").valueOf()} setRange={(dates) => setQuery({ ...Query, dates })} range={Query.dates} inputClass="!p-1.5 !text-xs" />}
						<TableSwitch mode={ViewMode} setMode={setViewMode} />
						{/* <ExpenseFilters /> */}
					</div>
				</div>
				{PendingReceipts.length > 0 && ReceiptStatus.value === "drafts" && (
					<div className="flex gap-2 justify-between mt-4">
						<div className="flex gap-8 p-4 rounded-xl border bg-light">
							<div className="flex gap-4 items-center">
								<h1 className="text-3xl">{PendingReceipts.length}</h1>
								<div className="text-sm">Expenses are ready for submission</div>
							</div>
							<div>
								<Button
									className="btn-sm"
									onClick={() => {
										if (ShowSelectExpenses) {
											setSelectedReceipts([]);
										}
										setShowSelectExpenses(!ShowSelectExpenses);
									}}
								>
									{ShowSelectExpenses ? "Cancel" : "Select Expenses"}
								</Button>
							</div>
						</div>
					</div>
				)}
				<TableCardRender
					loading={Loading}
					mode={ViewMode}
					table={
						<Table
							loading={Loading}
							className="mt-4 rounded-md border"
							nodes={Receipts.receipts.map(({ id, merchant, category, amount, date, createdAt, status, currency, categoryId, description, attachments, approvers }) => ({
								select:
									ReceiptStatus.value === "drafts" && status !== "draft" ? (
										<Checkbox checked={SelectedReceipts.some((r) => r.id === id)} onChange={() => handleSelect({ id, date, createdAt, amount, merchant, currency, categoryId, category, status, description, attachments, approvers })} />
									) : (
										<div />
									),
								id,
								merchant,
								category: category?.name,
								amount,
								date: StampToDate(date),
								createdAt: StampToDate(createdAt),
								status: <StatusIndicator status={status} id={id} />,
								actions: (
									<Button onClick={() => setOpenId(id)} variant="outlined" className="gap-2 btn-xs">
										<FiEye /> Open
									</Button>
								),
							}))}
							headers={[
								{ key: "select", label: "Select" },
								{ key: "id", label: "ID" },
								{ key: "merchant", label: "Merchant" },
								{ key: "category", label: "Category" },
								{ key: "amount", label: "Amount" },
								{ key: "date", label: "Expense Date" },
								{ key: "createdAt", label: "Submitted On" },
								{ key: "status", label: "Status" },
								{ key: "action", label: "Action" },
							]}
						/>
					}
					card={
						<CardsRenderer
							items={Receipts.receipts}
							render={(receipt, i) => (
								<Receipt
									selected={SelectedReceipts.some((r) => r.id === receipt.id)}
									onSelect={handleSelect}
									selectable={ShowSelectExpenses && ReceiptStatus.value === "drafts" && receipt.status !== "draft"}
									onReload={() => fetchReceipts(ReceiptStatus.value, Query)}
									onDrag={setDragging}
									key={i}
									{...receipt}
								/>
							)}
						/>
					}
				/>
				<ViewReceipt onReload={() => fetchReceipts(ReceiptStatus.value, Query)} receiptId={OpenId} onClose={() => setOpenId()} />
			</div>
			<BottomBar>
				<div className="w-full flex-center-between">
					<div className="gap-x-4 align-center">
						<AddReceipt onReload={() => fetchReceipts(ReceiptStatus.value, Query)} />
						<h5>
							{Receipts.count} Receipt {ReceiptStatus.label}
						</h5>
					</div>
					<div>
						<Pagination active={Query.page} total={Receipts.pages} onChange={(page) => setQuery({ ...Query, page })} />
					</div>
				</div>
			</BottomBar>
		</>
	);
}

export default WithMe;
